import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMeetings = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			rx: 6,
			fill: "#24A2C2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5 13.5L24 11.5V20.5L21.5 18.5V13.5Z",
			fill: "#DFF1FA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8,
			y: 11,
			width: 13,
			height: 10,
			rx: 2,
			fill: "#DFF1FA"
		})
	]
});
export default SvgMeetings;
